import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ResetManagedMeetingChanges as ResetManagedMeetingChangesMutation,
    ResetManagedMeetingChangesVariables as ResetManagedMeetingChangesMutationVariables,
    ManagedMeetingResetChangesInput,
} from 'nutshell-graphql-types';

import RESET_MANAGED_MEETING_CHANGES from '../mutations/reset-managed-meeting.graphql';

export function useResetManagedMeetingChanges(): {
    resetManagedMeetingChanges: (arg1: ManagedMeetingResetChangesInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [resetManagedMeetingChanges, {loading, error}] = useMutation<
        ResetManagedMeetingChangesMutation,
        ResetManagedMeetingChangesMutationVariables
    >(RESET_MANAGED_MEETING_CHANGES);

    return {
        resetManagedMeetingChanges: (input: ManagedMeetingResetChangesInput) =>
            resetManagedMeetingChanges({
                variables: {input},
            }).then(
                (result) =>
                    result &&
                    result.data &&
                    result.data.managedMeetingResetChanges &&
                    result.data.managedMeetingResetChanges.meeting
            ),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
